import { Component } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-wats-app',
  templateUrl: './whats-app.component.html',
  styleUrls: ['./whats-app.component.css'],
})
export class WhatsAppComponent {
  menuOpen = false;

  reviews = [
    {
      text: 'whatsapp_page.testimonials_1_text',
      author: 'whatsapp.testimonials_1_author',
    },
    {
      text: 'whatsapp.testimonials_2_text',
      author: 'whatsapp.testimonials_2_author',
    },
  ];

  protected faqList = [
    {
      question: 'whatsapp.faq_1_question',
      answer: 'whatsapp.faq_1_answer'
    },
    {
      question: 'whatsapp.faq_2_question',
      answer: 'whatsapp.faq_2_answer'
    },
    {
      question: 'whatsapp.faq_3_question',
      answer: 'whatsapp.faq_3_answer'
    },
    {
      question: 'whatsapp.faq_4_question',
      answer: 'whatsapp.faq_4_answer'
    },
    {
      question: 'whatsapp.faq_5_question',
      answer: 'whatsapp.faq_5_answer'
    },

  ]

  protected whatsappRules = [
    {
      rule: 'whatsapp.rule_1'
    },
    {
      rule: 'whatsapp.rule_2'
    },
    {
      rule: 'whatsapp.rule_3'
    },
    {
      rule: 'whatsapp.rule_4'
    },
    {
      rule: 'whatsapp.rule_5'
    },
  ]
  toggleMenu(): void {
    this.menuOpen = !this.menuOpen;
  }

  scrollTo(id: string): void {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
    if (this.menuOpen) {
      this.toggleMenu();
    }
  }

  protected readonly environment = environment;

}
